// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleListTool from './TiptapToggleListTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';
import { TiptapNodeType } from '../../../../../../common/tiptap/tiptapTypes';

const TiptapBulletedListTool = (props: ToolbarToolProps): ReactElement => (
    <TiptapToggleListTool {...props} listType={TiptapNodeType.bulletList} />
);

export default TiptapBulletedListTool;
